import React from "react"
import styles from "../../er-request/components/styles.module.scss";
import {InfoText} from "../../../shared";
import {useAppSelector} from "../../../core/hooks";

const PayInfoDp = () => {
  const {payment} = useAppSelector(state => state.requests)

  return (
    <div style={payment?.type !==1 ? {display: "none"} : {} } id={styles.patientInfo}>
      <p className={styles.title}>Оплата наличными</p>
      <div className={styles.wrapper}>
        <InfoText className={styles.InfoPayColor} title={'К оплате'} text={`${payment?.amount - payment?.paid_amount} руб. ${payment?.amount - payment?.paid_amount > 0 ? "Наличный расчёт! Оформите договор с заказчиком, примите сумму и пробейте чек!" : ""} `|| '-'}/>
      </div>
      <div className={styles.wrapper}>
      </div>
    </div>
  )
}

export default PayInfoDp
